import { styled } from '@mui/material';
import Slider from 'react-slick';
import Section from '../../../components/Section';

export const StyledButtonRight = styled('span')(({ theme }) => ({
  position: 'absolute',
  right: '-20px',
  padding: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: 'fit-content',
  borderRadius: '4px',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
}));

export const StyledButtonLeft = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: '-20px',
  padding: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: 'fit-content',
  borderRadius: '4px',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
}));

export const StyledAlsoLikeMobile = styled('div')(({ theme }) => ({
  display: 'none',
  padding: '0 16px',
  '@media only screen and (max-width: 768px)': {
    display: 'block',
  },
}));

export const StyledAlsoLikeDesktop = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '32px 0 0 0',
  gap: '48px',
  overflowX: 'hidden',
  '@media only screen and (max-width: 768px)': {
    maxHeight: '0px',
    margin: '0',
  },
}));

export const StyledProducts = styled(Section)(({ theme }) => ({
  padding: '0 0 38px 0 !important',
  overflow: 'visible',
  '& .slick-disabled': {
    display: 'none !important',
  },
}));

export const StyledSlideItem = styled(Slider)(({ theme }) => ({
  width: '1200px',
  display: 'flex !important',
  justifyContent: 'center',
  gap: '24px',
  outline: 'none',
  '.slick-prev': {
    left: '3% !important',
    zIndex: 1,
  },
  '.slick-next': {
    right: '3% !important',
    zIndex: 1,
  },
  '.slick-slider': {
    maxWidth: '1200px',
  },
}));
